var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.002,
    height: 10.002,
    viewBox: "0 0 10.002 10.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_39",
    "data-name": "Exclusion 39",
    d: "M-10737,3015a5.006,5.006,0,0,1-5-5,5.006,5.006,0,0,1,5-5,5.006,5.006,0,0,1,5,5A5.006,5.006,0,0,1-10737,3015Zm-1.979-7.856v5.688h.989v-2.114h1.175a2.319,2.319,0,0,0,1.537-.466,1.617,1.617,0,0,0,.55-1.3,1.68,1.68,0,0,0-.561-1.313,2.217,2.217,0,0,0-1.516-.5Zm2.175,2.782h-1.186v-1.987h1.213a1.076,1.076,0,0,1,.773.286.981.981,0,0,1,.283.736.925.925,0,0,1-.277.717A1.189,1.189,0,0,1-10736.8,3009.928Z",
    transform: "translate(10742.001 -3005)",
    fill: "#3a8814"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcParking);
export default __webpack_public_path__ + "static/media/ic_parking.75837a73056f79a132ae0ff9e3c64a69.svg";
export { ForwardRef as ReactComponent };